import styled from 'styled-components';

export const ChipWrapper = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__ChipWrapper", componentId: "sc-18ub4x0-0" })(["position:relative;display:inline-flex;align-items:center;justify-content:center;margin:0 8px 8px 0;padding:4px 8px;min-height:16px;min-width:24px;background-color:", ";border-radius:24px;box-sizing:border-box;"],








({ theme, $background }) => $background || theme.colors.Color1);




export const ChipText = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__ChipText", componentId: "sc-18ub4x0-1" })(["", ";font-size:8.5px;line-height:10px;color:#ffffff;"],
({ theme }) => theme.typography.SmallCapsHeadline);